// extracted by mini-css-extract-plugin
module.exports = {"reportStatusWrapper":"HistoryCheck_reportStatusWrapper__wapuz","ctasWrapper":"HistoryCheck_ctasWrapper__wNjK_","error":"HistoryCheck_error__2QcHG"};